const reasons = [
  {
    situation: 'Сотрудник регулярно не выполняет договорённости',
    consequence: 'Задачи остаются незавершёнными или выполняются некачественно, руководитель вынужден переделывать сам.',
  },
  {
    situation: 'Задачи приходится переделывать',
    consequence: 'Руководитель тратит время на исправление вместо управления, сотрудник не понимает, что именно сделано не так.',
  },
  {
    situation: 'Руководитель видит проблему, но не говорит о ней прямо',
    consequence: 'Проблема накапливается, сотрудник продолжает работать неправильно, ситуация ухудшается.',
  },
  {
    situation: 'Сотрудник воспринимает замечания как личную атаку',
    consequence: 'Руководитель избегает обратной связи, чтобы не испортить отношения, проблема остаётся нерешённой.',
  },
  {
    situation: 'Руководитель боится демотивировать сильного специалиста',
    consequence: 'Сотрудник не получает корректирующей обратной связи, его развитие замедляется.',
  },
  {
    situation: 'Разговор заканчивается обещанием «исправиться», но ничего не меняется',
    consequence: 'У руководителя накапливается разочарование, у сотрудника — ощущение, что проблема не настолько серьёзна.',
  },
  {
    situation: 'Конфликт между сотрудниками затягивается',
    consequence: 'Снижается эффективность команды, создаётся напряжённая атмосфера, страдает результат.',
  },
  {
    situation: 'Руководитель предпочитает сделать работу сам',
    consequence: 'Руководитель перегружается, сотрудники не развиваются, команда остаётся зависимой от одного человека.',
  },
  {
    situation: 'Сотрудники не понимают, что именно делают неправильно',
    consequence: 'Ошибки повторяются, потому что нет чёткой и своевременной обратной связи.',
  },
  {
    situation: 'Обратная связь даётся только когда ситуация стала критической',
    consequence: 'Разговор становится эмоциональным, сотрудник воспринимает его как неожиданную атаку, а не как управленческий инструмент.',
  },
];

export default function WhyManagersDelayDifficultConversations() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">
          Почему руководители откладывают сложные разговоры
        </h2>
        <p className="text-base md:text-lg text-gray-600 mb-12 max-w-3xl leading-relaxed">
          Реальные ситуации, с которыми ежедневно сталкиваются руководители, и почему избегание сложных разговоров не решает проблему, а только увеличивает её стоимость
        </p>

        <div className="grid sm:grid-cols-2 gap-4 mb-10">
          {reasons.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 p-4 md:p-5 hover:border-teal-300 transition-colors">
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-error-warning-line text-red-600 text-sm"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900 text-sm mb-1.5">{item.situation}</p>
                  <p className="text-gray-600 text-xs leading-relaxed">{item.consequence}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-3xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Отсутствие своевременной обратной связи редко решает проблему. Обычно оно только увеличивает её стоимость.
          </p>
        </div>
      </div>
    </section>
  );
}